<template>
  <div class="wrapper">
    <el-menu
      class="menu"
      mode="horizontal"
      text-color="#24274a"
      :default-active="$route.path"
      router
    >
      <el-menu-item index="/applications">Sites</el-menu-item>
    </el-menu>

    <router-view v-if="$route.name !== 'applications'" />

    <div v-else-if="applications.length === 0" class="align-center">
      <el-card>
        <h3>Looks like you don't have deployed anything ...</h3>

        <img src="../assets/hero/nothing-applications.svg" class="nothing" />

        <p>
          <el-button type="primary" @click.prevent="$router.push('/create')">Create an Application</el-button>
        </p>
      </el-card>
    </div>

    <div v-else id="applications">
      <el-row :gutter="20">
        <el-col
          v-for="application in data"
          :key="application.id"
          :xl="4"
          :lg="6"
          :md="6"
          :sm="8"
          :xs="12"
        >
          <ApplicationCard :application="application" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ApplicationCard from '../components/Application/Card'

export default {
  components: {
    ApplicationCard
  },
  data () {
    return {
      deploy: false,
      menu: 'account'
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    active () {
      return '/' + (this.$route.path || '').substring(1).split('/').shift()
    },
    data () {
      return this.applications
        .filter((a) => a.state !== 'stopped')
        .sort((a, b) => b.created - a.created)
    },
    ...mapState(['applications', 'instances']),
    ...mapGetters(['permission'])
  },
  beforeMount () {
    if (this.permission('accounting')) {
      this.$router.push('/billing')
    }
    if (this.instances.length === 0) {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../theme";

  h2 .el-button {
    float: right;
  }
  .wrapper {
    background-image: linear-gradient(to bottom, $--background-color-gradient, $--background-color-base);

    > .el-menu {
      margin-top: 0 !important;
    }
  }

  .nothing {
    max-height: 300px;
    padding: 50px 0 25px;
  }

  .deploy {
    margin-top: 15px;
  }

  #applications {
    .application {
      margin-bottom: 24px;
    }
  }
</style>
